import { render, staticRenderFns } from "./StoreDetails.vue?vue&type=template&id=5c9b5e3b&scoped=true&"
import script from "./StoreDetails.vue?vue&type=script&lang=js&"
export * from "./StoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./StoreDetails.vue?vue&type=style&index=0&id=5c9b5e3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b5e3b",
  null
  
)

export default component.exports